import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import useGetClientId from "../hooks/useGetClientId";
import { useEffect, useState } from "react";
import LoadingComponent from "./common/LoadingComponent"; 

export default function RoleBasedRoute({ allowedRoles, children }) {
  const { userObj } = useSelector((state) => state.user);
  const clientObj = useGetClientId();
  const navigate = useNavigate();
  const { clientNameParam } = useParams();

  const [ready, setReady] = useState(false);
   if (!userObj || !clientObj) {
    navigate("/client");
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(true);
    }, 600); 
    return () => clearTimeout(timer);
  }, []);

  if (!ready || !userObj || !clientObj) {
    return <LoadingComponent loading={true} />;
  }

  const roleId = Number(clientObj?.roleId);

  if (!allowedRoles.includes(roleId)) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
        <h2 className="text-danger fw-bold">Access Denied</h2>
        <p className="mt-3 fs-5">
          You do not have permission to access this page.
          <br />
          Please contact your administrator.
        </p>
        <button
          type="button"
          className="btn btn-primary mt-3"
          onClick={() =>
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                clientNameParam,
              })
            )
          }
        >
          Back to Home
        </button>
      </div>
    );
  }

  return children;
}
 